Ext.define('SA.view.sidebar.business.searcheditor.CodeList', {
    extend: 'Ext.Component',
    alias: 'widget.business-code-list',

    autoEl: {tabIndex: -1},
    cls: 'sa-business-editor-code-list',
    floating: true,
    focusOnToFront: false,
    maxHeight: 300,

    tpl: [
        '<tpl if="!length">',
            '<div class="sa-business-editor-code-list-empty">No matching codes found</div>',
        '</tpl>',
        '<tpl for=".">',
            '<div class="sa-business-editor-code-list-item" data-code="{code}">{text}</div>',
        '</tpl>'
    ],

    getRefOwner() {
        return this.field;
    },

    initEvents() {
        var el = this.el;

        this.callParent();

        el.on({
            delegate: '.sa-business-editor-code-list-item',

            click: (ev, target) => {
                var code = target.getAttribute('data-code');

                this.field.setValue(code);
                this.field.focus();
            },

            mousedown: () => {
                this.fireEvent('mousedown:item', this);
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-business-editor-code-list-item-hover');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-business-editor-code-list-item-hover');
            }
        });

        el.on({
            blur: () => {
                this.fireEvent('blur', this);
            },

            focus: () => {
                this.fireEvent('focus', this);
            }
        });
    }
});